import merge from "deepmerge";
export function deepMerge(mergedInto, toMerge) {
  return merge(mergedInto, toMerge, {
    arrayMerge: function arrayMerge(destination, source) {
      return source;
    }
  });
}